import { render, staticRenderFns } from "./contactDataListItems.vue?vue&type=template&id=3e8ef362"
import script from "./contactDataListItems.vue?vue&type=script&lang=ts"
export * from "./contactDataListItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports